<template>
  <div class="app-container">
    <!-- 查询区域 -->
    <a-form
        layout="inline"
        :model="queryParams"
        class="search-form"
    >
      <a-form-item label="片商名称">
        <a-input
            v-model="queryParams.merchantName"
            placeholder="请输入片商名称"
            allow-clear
            style="width: 240px"
        />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="handleQuery">
          搜索
        </a-button>
      </a-form-item>

      <a-form-item style="margin-left: 16px">
        <a-button type="primary" @click="handleAdd">
          新增
        </a-button>
      </a-form-item>
    </a-form>

    <!-- 表格区域 -->
    <a-table
        class="mt16"
        :loading="loading"
        :data-source="list"
        :columns="columns"
        row-key="id"
        :pagination="pagination"
        @change="handleTableChange"
        bordered
    >
      <!-- 状态列 -->
      <span slot="status" slot-scope="text">
        <a-badge
            :status="text === 1 ? 'success' : 'default'"
            :text="statusText(text)"
        />
      </span>

      <!-- 片商分组列 -->
      <span slot="filmGroup" slot-scope="text">
        {{ filmGroupText(text) }}
      </span>

      <!-- 操作列 -->
      <span slot="action" slot-scope="text, record">
        <a @click="handleUpdate(record)">修改</a>
        <a-divider type="vertical" />
        <!-- 正常时可以冻结 -->
        <a-popconfirm
            v-if="record.status === 1"
            title="确认冻结该账号？"
            @confirm="handleFrozen(record)"
        >
          <a>冻结</a>
        </a-popconfirm>
        <!-- 冻结时可以启用 -->
        <a-popconfirm
            v-else
            title="确认启用该账号？"
            @confirm="handleEnable(record)"
        >
          <a>启用</a>
        </a-popconfirm>
      </span>
    </a-table>

    <!-- 新增 / 修改 弹窗 -->
    <a-modal
        :visible="open"
        :title="modalTitle"
        :confirm-loading="confirmLoading"
        @ok="submitForm"
        @cancel="cancel"
        destroyOnClose
        width="480px"
    >
      <a-form-model
          ref="formRef"
          :model="form"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          autocomplete="off"
      >
        <a-form-model-item label="片商名称" prop="merchantName">
          <a-input
              v-model="form.merchantName"
              placeholder="请输入片商名称"
          />
        </a-form-model-item>

        <a-form-model-item label="账号" prop="account">
          <a-input
              v-model="form.account"
              placeholder="请输入账号"
              autocomplete="off"
              name="film-account"
          />
        </a-form-model-item>

        <a-form-model-item label="密码" prop="password">
          <a-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              autocomplete="new-password"
              name="film-password"
          />
        </a-form-model-item>

        <!-- 片商分组 -->
        <a-form-model-item label="片商分组" prop="filmGroupCode">
          <a-select
              v-model="form.filmGroupCode"
              placeholder="请选择片商分组"
              style="width: 100%;"
              allow-clear
          >
            <a-select-option value="001">
              A组：每 1000 次播放 = RM10.00
            </a-select-option>
            <a-select-option value="002">
              B组：每 1000 次播放 = RM7.00
            </a-select-option>
            <a-select-option value="003">
              C组：每 1000 次播放 = RM5.00
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { pageMerchantUser, addFilmUser, updateFilmUser, changeFilmUserStatus } from '@/api/user/merchantUser'

export default {
  name: 'VideoMerchant',
  data() {
    return {
      loading: false,
      // 列表查询参数（按后端要求：pageNum pageSize merchantName）
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        merchantName: undefined
      },
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      columns: [
        { title: 'ID', dataIndex: 'id', align: 'center', width: 80 },
        { title: '片商名称', dataIndex: 'merchantName', align: 'center' },
        { title: '账号', dataIndex: 'account', align: 'center' },
        { title: '短剧', dataIndex: 'dramaCount', align: 'center' },
        { title: '观看总数', dataIndex: 'totalViewCount', align: 'center' },
        { title: '总收益', dataIndex: 'totalIncome', align: 'center' },
        {
          title: '片商分组',
          dataIndex: 'filmGroupCode',
          align: 'center',
          scopedSlots: { customRender: 'filmGroup' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],

      /** 新增/修改弹窗相关 */
      open: false,
      modalTitle: '',
      confirmLoading: false,
      form: {
        id: undefined,
        merchantName: '',
        account: '',
        password: '',
        filmGroupCode: undefined // 片商分组：001 / 002 / 003
      },
      rules: {
        merchantName: [
          {
            validator: (rule, value) => {
              if (!this.form.id && (!value || String(value).trim() === '')) {
                return Promise.reject(new Error('片商名称不能为空'))
              }
              return Promise.resolve()
            },
            trigger: 'blur'
          }
        ],
        account: [
          {
            validator: (rule, value) => {
              if (!this.form.id && (!value || String(value).trim() === '')) {
                return Promise.reject(new Error('账号不能为空'))
              }
              return Promise.resolve()
            },
            trigger: 'blur'
          }
        ],
        password: [
          {
            validator: (rule, value) => {
              if (!this.form.id && (!value || String(value).trim() === '')) {
                return Promise.reject(new Error('密码不能为空'))
              }
              return Promise.resolve()
            },
            trigger: 'blur'
          }
        ],
        filmGroupCode: [
          {
            validator: (rule, value) => {
              if (!value) {
                return Promise.reject(new Error('片商分组不能为空'))
              }
              return Promise.resolve()
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  watch: {
    // 监听搜索框内容变化
    'queryParams.merchantName'(val) {
      // 如果被清空（null、undefined、空字符串），刷新到第1页
      if (!val) {
        this.queryParams.pageNum = 1
        this.pagination.current = 1
        this.getList()
      }
    }
  },
  methods: {
    /** 获取列表（调用后端分页接口） */
    getList() {
      this.loading = true
      pageMerchantUser(this.queryParams)
          .then(res => {
            const page = res.records ? res : res.data || {}

            this.list = page.records || []
            this.pagination.total = page.total || 0
            this.pagination.current =
                page.current || this.queryParams.pageNum || 1
            this.pagination.pageSize =
                page.size || this.queryParams.pageSize || 10

            // 同步回查询条件
            this.queryParams.pageNum = this.pagination.current
            this.queryParams.pageSize = this.pagination.pageSize
          })
          .finally(() => {
            this.loading = false
          })
    },

    /** 搜索 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.pagination.current = 1
      this.getList()
    },

    /** 打开新增弹窗 */
    handleAdd() {
      this.resetForm()
      this.modalTitle = '新增片商'
      this.open = true
    },

    /** 打开修改弹窗 */
    handleUpdate(record) {
      this.resetForm()
      this.form.id = record.id
      this.form.merchantName = record.merchantName
      this.form.account = record.account
      // 密码通常不回显，这里留空由用户重新输入
      this.form.filmGroupCode = record.filmGroupCode || undefined
      this.modalTitle = '修改片商'
      this.open = true
    },

    /** 重置表单对象 */
    resetForm() {
      this.form = {
        id: undefined,
        merchantName: '',
        account: '',
        password: '',
        filmGroupCode: undefined
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },

    /** 弹窗取消 */
    cancel() {
      this.open = false
    },

    /** 提交表单（新增 / 修改） */
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return
        }
        this.confirmLoading = true

        // 根据是否有 id 判断是新增还是编辑
        const api = this.form.id ? updateFilmUser : addFilmUser

        api(this.form)
            .then(() => {
              this.$message.success(this.form.id ? '修改成功' : '新增成功')
              this.open = false
              this.getList()
            })
            .finally(() => {
              this.confirmLoading = false
            })
      })
    },

    /** 冻结（status 改为 0） */
    handleFrozen(record) {
      this.loading = true
      changeFilmUserStatus(record.id, 0)
          .then(() => {
            this.$message.success('冻结成功')
            // 刷新列表，保证和后端状态一致
            this.getList()
          })
          .finally(() => {
            this.loading = false
          })
    },

    /** 启用（status 改为 1） */
    handleEnable(record) {
      this.loading = true
      changeFilmUserStatus(record.id, 1)
          .then(() => {
            this.$message.success('启用成功')
            this.getList()
          })
          .finally(() => {
            this.loading = false
          })
    },

    /** 分页变化 */
    handleTableChange(pagination) {
      this.pagination = { ...this.pagination, ...pagination }
      this.queryParams.pageNum = pagination.current
      this.queryParams.pageSize = pagination.pageSize
      this.getList()
    },

    /** 状态显示文字 */
    statusText(value) {
      return value === 1 ? '正常' : '冻结'
    },

    /** 片商分组显示文字 */
    filmGroupText(code) {
      if (code === '001') return 'A组：1000 播放 = RM10.00'
      if (code === '002') return 'B组：1000 播放 = RM7.00'
      if (code === '003') return 'C组：1000 播放 = RM5.00'
      return '-'
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 16px;
}

.search-form {
  margin-bottom: 16px;
}

.mt16 {
  margin-top: 16px;
}
</style>
